var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SpinnerButton } from '../SpinnerButton/SpinnerButton';
export function FormNavigation(props) {
    var _a = props.backCaption, backCaption = _a === void 0 ? 'Zurück' : _a, _b = props.submitCaption, submitCaption = _b === void 0 ? 'Weiter' : _b, handleBack = props.handleBack, switching = props.switching, handleClick = props.handleClick;
    return (_jsx("div", __assign({ className: "actions" }, { children: _jsx("nav", __assign({ className: "form-navigation" }, { children: _jsxs("ul", { children: [_jsx("li", __assign({ className: "previous" }, { children: _jsx(SpinnerButton, { caption: backCaption, type: "button", clickHandler: handleBack, isDisabled: switching, secondary: true }) })), _jsx("li", __assign({ className: "next" }, { children: _jsx(SpinnerButton, { caption: submitCaption, isLoading: switching, clickHandler: handleClick }) }))] }) })) })));
}
